var map = {
	"./calendar.png": "6959",
	"./clientes-level.png": "2001",
	"./clientes.png": "b1f0",
	"./dashboard-level.png": "54bf",
	"./dashboard.png": "0316",
	"./email-form.png": "b80a",
	"./excel-file.png": "7218",
	"./image-file.png": "a4c1",
	"./link_icon_grey.png": "d176",
	"./lock-icon.png": "fff8",
	"./pdf-file.old.png": "cacb",
	"./pdf-file.png": "e4f5",
	"./search.png": "8f8b",
	"./servicios-level.png": "bb6f",
	"./servicios.png": "a892",
	"./share_icon_grey.png": "8651",
	"./upload-icon.png": "25d5",
	"./upload_icon_grey.png": "cbff",
	"./web-file.png": "2176",
	"./word-file.png": "4e88"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";